import { memo } from 'react'

import TimeSlot from '@/molecules/TimeSlot'
import Product from '@/ts/Product'

function List({ product }: ListProps) {
  return (
    <ul className="w-full space-y-6">
      {product.time_slots.slice(0, 2).map((slot) => (
        <li
          className="pb-4 border-b border-sbtviolet-100 last:pb-0 last:border-none"
          key={slot.id}
        >
          {product?.status === 'active' && (
            <TimeSlot product={product} slot={slot} />
          )}
        </li>
      ))}
    </ul>
  )
}

interface ListProps {
  product: Product
}

export default memo(List)
